import { useMutation } from 'react-query';
import { googleMapsDao } from 'shared/dao/googleMapsDao';
import { IGeolocationRequestPayload, IGeolocationResponsePayload } from 'shared/interfaces/IGeolocation';
import { IAxiosErrorResponse } from 'shared/interfaces/utils/IAxios';

const { geolocate: geolocateDao } = googleMapsDao();
export const googleMapsService = () => {
  const geolocate = () => {
    return useMutation((payload: IGeolocationRequestPayload) => geolocateDao(payload));
  };

  return {
    geolocate,
  };
};
